/* eslint-disable import/prefer-default-export */
export const isEmpty = (value) => Object.keys(value)?.length === 0;
